/** Tagged template that URI-encodes EVERY `${}` interpolation. Keep base URLs (with `://`) outside it: `baseUrl + u`/path/${id}``. */
export const u = (strings: TemplateStringsArray, ...values: unknown[]) =>
  strings.reduce((acc, s, i) => acc + s + (i < values.length ? encodeURIComponent(String(values[i])) : ''), '')
